import { defineStore } from "pinia";
import useProductDataStore from "./productDataStore.mjs";
import useProductBuyBoxStore from "./productBuyBoxStore.mjs";
import useProductAppPropsStore from "./productAppPropsStore.mjs";
const useProductPageStore = defineStore("productPageStore", {
  getters: {
    computedSelectedColor() {
      const { selectedColor, tempColor } = useProductBuyBoxStore();
      const { availableColors } = useProductDataStore();
      let selected = tempColor;
      if (selectedColor == null ? void 0 : selectedColor.displayLabel) selected = selectedColor;
      else if (availableColors.length === 1) [selected] = availableColors;
      return selected;
    },
    computedSelectedSize() {
      var _a, _b;
      const { product } = useProductDataStore();
      const { selectedSize } = useProductBuyBoxStore();
      const isColorSelected = !!((_a = this.computedSelectedColor) == null ? void 0 : _a.code);
      const { byColor, displayOptions, sizes } = product;
      let selected = "";
      if (selectedSize) selected = selectedSize;
      else if (sizes.length === 1) [selected] = sizes;
      else if (displayOptions.showSkuDropDown && isColorSelected) {
        const sizesForColor = (_b = byColor == null ? void 0 : byColor[this.computedSelectedColor.code]) == null ? void 0 : _b.available;
        if (sizesForColor.length === 1) [selected] = sizesForColor;
      }
      return selected;
    },
    computedSelectedSku() {
      const { product, sellableSkus } = useProductDataStore();
      let selectedSku;
      const { bySize } = product;
      if (!!this.computedSelectedSize && !!this.computedSelectedColor) {
        selectedSku = bySize[this.computedSelectedSize][this.computedSelectedColor.code];
      } else if (product.displayOptions.showSkuDropDown && sellableSkus.length === 1) {
        [selectedSku] = sellableSkus;
      }
      return selectedSku;
    },
    computedIsMemberOnly() {
      var _a;
      const { product } = useProductDataStore();
      return product.allSkusAreMembersOnly || !!((_a = this.computedSelectedSku) == null ? void 0 : _a.membersOnly);
    },
    computedIsFreeShipping() {
      var _a, _b, _c, _d;
      const threshold = Number((_a = useProductAppPropsStore().appPropsMap.textStrings) == null ? void 0 : _a.shippingThreshold);
      return Number((_d = (_c = (_b = this.computedSelectedSku) == null ? void 0 : _b.price) == null ? void 0 : _c.price) == null ? void 0 : _d.value) >= threshold;
    },
    computedIsPreorder() {
      var _a;
      const { product } = useProductDataStore();
      return product.allDisplayableSkusArePreorder || ((_a = this.computedSelectedSku) == null ? void 0 : _a.status) === "PRE_ORDER";
    }
  },
  actions: {
    initProductPageCreateStart() {
      const { product } = useProductDataStore();
      if (!product.displayOptions.showSkuDropDown) this.preselectFeaturedColor();
      return product.displayOptions;
    },
    initProductPageCreated() {
    },
    initProductPageMount() {
    },
    preselectFeaturedColor() {
      var _a;
      const { product } = useProductDataStore();
      const { selectedColor, selectedSku, handleColorChange } = useProductBuyBoxStore();
      const colorCode = product.displayOptions.featuredImage.color.code;
      const color = product.colors.find((fullColor) => fullColor.code === colorCode);
      const hasSelectedColor = !!(selectedColor == null ? void 0 : selectedColor.code) || !!((_a = selectedSku == null ? void 0 : selectedSku.color) == null ? void 0 : _a.code);
      if (!!color && !hasSelectedColor) {
        const price = product.priceByColor[colorCode];
        handleColorChange({ color, price });
      }
    }
  }
});
export {
  useProductPageStore as default
};
//# sourceMappingURL=productPageStore.mjs.map
